// src/pages/super-admin/reports/ReportsList.tsx

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

import UploadReport from "./UploadReport";
import ReportDetails from "./ReportDetails";

export default function ReportsList() {
  const [reports] = useState([
    {
      id: 1,
      client: "Medicare Staffing",
      user: "John Carter",
      test: "5 Panel Drug Test",
      date: "2025-01-10",
      status: "COMPLETED",
    },
  ]);

  const [selectedReport, setSelectedReport] = useState<any>(null);
  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <div className="space-y-6 p-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold">Reports Management</h1>

        <Dialog>
          <DialogTrigger asChild>
            <Button>Upload Report</Button>
          </DialogTrigger>

          <DialogContent className="max-w-lg">
            <DialogHeader>
              <DialogTitle>Upload Report</DialogTitle>
            </DialogHeader>

            <UploadReport />
          </DialogContent>
        </Dialog>
      </div>

      {/* REPORTS TABLE */}
      <Card>
        <CardHeader>
          <CardTitle>All Reports</CardTitle>
        </CardHeader>

        <CardContent>
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b text-left">
                <th className="p-3">Client</th>
                <th className="p-3">User</th>
                <th className="p-3">Test</th>
                <th className="p-3">Date</th>
                <th className="p-3">Status</th>
                <th className="p-3">Actions</th>
              </tr>
            </thead>

            <tbody>
              {reports.map((r) => (
                <tr key={r.id} className="border-b">
                  <td className="p-3">{r.client}</td>
                  <td className="p-3">{r.user}</td>
                  <td className="p-3">{r.test}</td>
                  <td className="p-3">{r.date}</td>
                  <td className="p-3">{r.status}</td>
                  <td className="p-3">
                    <Button
                      size="sm"
                      onClick={() => {
                        setSelectedReport(r);
                        setDetailsOpen(true);
                      }}
                    >
                      View
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardContent>
      </Card>

      {/* REPORT DETAILS POPUP */}
      <Dialog open={detailsOpen} onOpenChange={setDetailsOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader>
            <DialogTitle>Report Details</DialogTitle>
          </DialogHeader>

          {selectedReport && (
            <ReportDetails
              report={selectedReport}
              onClose={() => setDetailsOpen(false)}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
